module.exports = "input[type=\"number\"]::-webkit-outer-spin-button,\r\ninput[type=\"number\"]::-webkit-inner-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\ninput[type=\"number\"] {\r\n    -moz-appearance:textfield;\r\n}\r\n\r\ninput {\r\n    ime-mode:disabled;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/parts/b-datefromto1/b-datefromto1.component.css
// module id = ./src/app/parts/b-datefromto1/b-datefromto1.component.css
// module chunks = main